import ScratchStorage from 'scratch-storage';

import defaultProject from './default-project';

const customSprites = require.context('../containers/state-sprites', false, /\.(png|jpe?g|svg)$/);
const customBackDrop = require.context('../containers/custome-backdrop', false, /\.(png|jpe?g|svg)$/);


/**
 * Wrapper for ScratchStorage which adds default web sources.
 * @todo make this more configurable
 */
class Storage extends ScratchStorage {
    constructor() {
        super();
        this.cacheDefaultProject();
    }
    addOfficialScratchWebStores() {
        this.addWebStore(
            [this.AssetType.Project],
            this.getProjectGetConfig.bind(this),
            this.getProjectCreateConfig.bind(this),
            this.getProjectUpdateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.ImageVector, this.AssetType.ImageBitmap, this.AssetType.Sound],
            this.getAssetGetConfig.bind(this),
            // We set both the create and update configs to the same method because
            // storage assumes it should update if there is an assetId, but the
            // asset store uses the assetId as part of the create URI.
            this.getAssetCreateConfig.bind(this),
            this.getAssetCreateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.Sound],
            asset => `static/extension-assets/scratch3_music/${asset.assetId}.${asset.dataFormat}`
        );
    }
    setProjectHost(projectHost) {
        this.projectHost = projectHost;
    }
    setProjectToken(projectToken) {
        this.projectToken = projectToken;
    }
    getProjectGetConfig(projectAsset) {
        const path = `${this.projectHost}/${projectAsset.assetId}`;
        const qs = this.projectToken ? `?token=${this.projectToken}` : '';
        return path + qs;
    }
    getProjectCreateConfig() {
        return {
            url: `${this.projectHost}/`,
            withCredentials: true
        };
    }
    getProjectUpdateConfig(projectAsset) {
        return {
            url: `${this.projectHost}/${projectAsset.assetId}`,
            withCredentials: true
        };
    }
    setAssetHost(assetHost) {
        this.assetHost = assetHost;
    }
    getAssetGetConfig(asset) {
        const predefinedIds = ['1a2b3c4d5e6f708192a3b4c5d6e7f809', '2b3c4d5e6f708192a3b4c5d6e7f8091a',
             '3c4d5e6f708192a3b4c5d6e7f8091a2b', '4d5e6f708192a3b4c5d6e7f8091a2b3c', '5e6f708192a3b4c5d6e7f8091a2b3c4d',
              '6f708192a3b4c5d6e7f8091a2b3c4d5e', '8192a3b4c5d6e7f8091a2b3c4d5e6f80', '708192a3b4c5d6e7f8091a2b3c4d5e6f', 
              '8192a3b4c5d6e7f8091a2b3c4d5e6f70', '92a3b4c5d6e7f8091a2b3c4d5e6f7081', 'a3b4c5d6e7f8091a2b3c4d5e6f708192', 
              'b4c5d6e7f8091a2b3c4d5e6f708192a3', 'c5d6e7f8091a2b3c4d5e6f708192a3b4', 'd6e7f8091a2b3c4d5e6f708192a3b4c5', 
              'e7f8091a2b3c4d5e6f708192a3b4c5d6', 'f8091a2b3c4d5e6f708192a3b4c5d6e7', '091a2b3c4d5e6f708192a3b4c5d6e7f8', 
              '1f2e3d4c5b6a798087a6b5c4d3e2f109', '2e3d4c5b6a798087a6b5c4d3e2f1091a', '3d4c5b6a798087a6b5c4d3e2f1091a2b', 
              '4c5b6a798087a6b5c4d3e2f1091a2b3c', '5b6a798087a6b5c4d3e2f1091a2b3c4d', '6a798087a6b5c4d3e2f1091a2b3c4d5e', 
              '798087a6b5c4d3e2f1091a2b3c4d5e6f', '8087a6b5c4d3e2f1091a2b3c4d5e6f70', '87a6b5c4d3e2f1091a2b3c4d5e6f7081', 
              'a6b5c4d3e2f1091a2b3c4d5e6f708192', 'b5c4d3e2f1091a2b3c4d5e6f708192a3', 'c4d3e2f1091a2b3c4d5e6f708192a3b4'];
              
        const predefinedBackdropIds = ['a0860bdf5a25c7f1bd4927f630091da2', 'confused rabbit', 'Happy rabbit','multiple','Maze 1','Maze 2','park','magicai-Scene','Treasure map'];

        console.log('Asset ID:', asset.assetId, 'Asset Format:', asset.dataFormat);

        if (predefinedIds.includes(asset.assetId)) {
            console.log('Using custom sprite');
            return customSprites(`./${asset.assetId}.${asset.dataFormat}`);
        }

        if (predefinedBackdropIds.includes(asset.assetId)) {
            console.log('Using custom backdrop');
            return customBackDrop(`./${asset.assetId}.${asset.dataFormat}`);
        }

        console.log('Using default asset host');
        return `${this.assetHost}/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
    }
    getAssetCreateConfig(asset) {
        return {
            // There is no such thing as updating assets, but storage assumes it
            // should update if there is an assetId, and the asset store uses the
            // assetId as part of the create URI. So, force the method to POST.
            // Then when storage finds this config to use for the "update", still POSTs
            method: 'post',
            url: `${this.assetHost}/${asset.assetId}.${asset.dataFormat}`,
            withCredentials: true
        };
    }
    setTranslatorFunction(translator) {
        this.translator = translator;
        this.cacheDefaultProject();
    }
    cacheDefaultProject() {
        const defaultProjectAssets = defaultProject(this.translator);
        defaultProjectAssets.forEach(asset => this.builtinHelper._store(
            this.AssetType[asset.assetType],
            this.DataFormat[asset.dataFormat],
            asset.data,
            asset.id
        ));
    }
}

const storage = new Storage();

export default storage;
